import { useTranslation } from 'react-i18next'
import { Button } from '@/shared/components/button'
import { appConfig } from '@/shared/config/app-config'

interface ErrorFallbackProps {
  // Called before the page reloads (e.g. retry analytics).
  onRetry?: () => void
}

export function ErrorFallback({ onRetry }: ErrorFallbackProps) {
  const { t } = useTranslation()

  return (
    <div className="flex h-full flex-col items-center justify-center gap-[24px] px-[24px]">
      <div className="flex flex-col items-center gap-[8px] text-center">
        <p className="font-display text-[24px] font-medium leading-[32px] text-app-grey-900">
          {t('error_screen_wrong_title')}
        </p>
        <p className="max-w-[300px] font-sans text-[16px] leading-[22px] tracking-[-0.32px] text-app-grey-600">
          {t('error_screen_contact_text')}
          <a
            href={`mailto:${appConfig.supportEmail}`}
            className="font-medium text-primary"
          >
            {appConfig.supportEmail}
          </a>
        </p>
      </div>
      <div className="w-[150px]">
        <Button
          onClick={() => {
            onRetry?.()
            window.location.reload()
          }}
        >
          {t('error_screen_retry_action')}
        </Button>
      </div>
    </div>
  )
}

export function RootErrorFallback() {
  return (
    <div className="flex h-dvh flex-col">
      <ErrorFallback />
    </div>
  )
}
